import i18n from "@/i18n"

export default function(value) {
    if (value == null) return null
    if (value[i18n.locale]) return value[i18n.locale]
    else if (value["de"]) return value["de"]
    else if (value["en"]) return value["en"]
    return null
}